import { PayloadAction, SerializedError, createSlice } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import {
  CommonSearchState,
  IAlertPlacement,
  clearFacetAlertToShowHelper,
  clearFilterHelper,
  clearFiltersWithRegexHelper,
  createSuccessHelper,
  createToggleFilterHelper
} from '../helpers/search';
import { FILTERS } from '@/components/ui/SearchResults/constants';

export type FindAProgramState = CommonSearchState & {
  facetAlertToShow: IAlertPlacement | undefined;
};

const initialFindAProgramState: FindAProgramState = {
  data: null,
  request: null,
  isLoading: false,
  isFetching: false,
  error: null,
  adHocFilters: [],
  preselectedFiltersThatHaveBeenDeselected: [],
  facetAlertToShow: undefined
};

const ALLOWED_AD_HOC_FILTERS = [FILTERS.JURISDICTIONS, FILTERS.PRACTICE_AREA];

const findAProgramSlice = createSlice({
  name: 'findAProgram',
  initialState: initialFindAProgramState,
  reducers: {
    findAProgramLoading: (state, payload: PayloadAction<'loading' | 'fetching' | 'none'>) => {
      state.isLoading = payload.payload === 'loading';
      state.isFetching = payload.payload === 'fetching';
    },
    findAProgramSuccess: createSuccessHelper(ALLOWED_AD_HOC_FILTERS),
    findAProgramFailure: (state, action: PayloadAction<FetchBaseQueryError | SerializedError>) => {
      state.isLoading = false;
      state.isFetching = false;
      state.error = action.payload;
    },
    toggleFindAProgramFilter: createToggleFilterHelper(ALLOWED_AD_HOC_FILTERS),
    clearFindAProgramFilters: clearFilterHelper,
    clearFiltersWithRegex: clearFiltersWithRegexHelper,
    resetFindAProgram: () => initialFindAProgramState,
    clearFacetAlertToShow: clearFacetAlertToShowHelper
  }
});

export const {
  findAProgramLoading,
  findAProgramSuccess,
  findAProgramFailure,
  toggleFindAProgramFilter,
  clearFindAProgramFilters,
  clearFiltersWithRegex,
  resetFindAProgram,
  clearFacetAlertToShow
} = findAProgramSlice.actions;

export default findAProgramSlice.reducer;
